<section class="p-2 p-md-4">
  <div *ngIf="!cliente" class="card mb-4">
    <div class="card-body">
      <div class="d-flex flex-column align-items-end">
        <label for class="img-container rounded bg-gray-400">
          <img src="{{image}}" alt="">
        </label>
        <label [hidden]="image!=null" class="btn btn-theme btn-icon mt-4" for="inputGroupFile01">
          <input [readonly]="desativarInputsEBotoes" autocomplete="false" #imageInputFile type="file" accept="image/*" (change)="addImage($event)" class="d-none" id="inputGroupFile01">
          <span>Selecionar Imagem</span>
          <i class="mdi mdi-image"></i>
        </label>
        <button *ngIf="!desativarInputsEBotoes" [hidden]="image==null" (click)="removeImage();" class="btn btn-danger btn-icon mt-4">
          <span>Remover Imagem</span>
          <i class="mdi mdi-close"></i>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="!cliente" class="card mb-4">
    <div class="card-header bg-white">
      <h3>
        Cor do sistema
      </h3>
    </div>
    <div *ngIf="!desativarInputsEBotoes" class="card-body row">
      <div  *ngFor="let c of colors" class="">
        <app-input-radio [value]="c" (modelChange)="setColor(c)" [model]="unidade.cor" (click)="setColor(c)" color="text-{{c}}" [outline]="false" class="bg-{{c}} m-2 rounded radio-color-container"
          size="sm"></app-input-radio>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header bg-white">
      <h3>
        Dados de cadastro
      </h3>
    </div>
    <div class="card-body">
      <div class="row">
        <ng-container *ngIf="unidade.tipoDocumento=='CPF'">
          <div class="col-12 col-lg-4 p-2">
            <label for="cpf">CPF</label>
            <input [readonly]="desativarInputsEBotoes" type="text" required [textMask]="masks.cpf" autocomplete="false" class="form-control input-validate" [formControl]="form.controls.cpf" id="cpf" name="cpf">
            <app-msg-erro [control]="form.controls.cpf"></app-msg-erro>
          </div>
        </ng-container>
        <ng-container *ngIf="unidade.tipoDocumento=='CNPJ'">
          <div class="col-12 col-lg-4 p-2">
            <label for="cnpj">CNPJ</label>
            <input [readonly]="desativarInputsEBotoes" type="text" required [textMask]="masks.cnpj" autocomplete="false" (blur)="consultarCNPJ($event)" class="form-control input-validate" [formControl]="form.controls.cnpj" id="cnpj" name="cnpj" minlength="18" maxlength="18">
            <app-msg-erro [control]="form.controls.cnpj"></app-msg-erro>
          </div>
          <div class="col-12 col-lg-4 p-2">
            <label for="razaosocial">Razão Social</label>
            <input [readonly]="desativarInputsEBotoes" type="text" required autocomplete="false" class="form-control input-validate" [formControl]="form.controls.razaoSocial" name="razaosocial" id="razaosocial">
            <app-msg-erro [control]="form.controls.razaoSocial"></app-msg-erro>
          </div>
        </ng-container>
        <div class="col-12 col-lg-4 p-2">
          <label for="nomefantasia">Nome {{unidade.tipoDocumento == 'CNPJ' ? 'Fantasia' : '' }}</label>
          <input [readonly]="desativarInputsEBotoes" type="text" required autocomplete="false" class="form-control input-validate" [formControl]="form.controls.nomeFantasia" name="nomefantasia" id="nomefantasia">
          <app-msg-erro [control]="form.controls.nomeFantasia"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-4 p-2" *ngIf="campoEditavel">
          <label for="unidadepai">Unidade Pai</label>
          <select required class="form-control input-validate" [formControl]="form.controls.unidadePai" name="unidadepai" id="unidadepai">
            <!-- option value="">Selecione</option-->
            <option *ngFor="let o of listaUnidades" [value]="o.uuid">{{o.nomeFantasia}}</option>
          </select>
          <app-msg-erro [control]="form.controls.unidadePai"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-4 p-2" *ngIf="campoEditavel">
          <label for="unidadetipo">Tipo  {{cliente ? 'Cliente' : 'Unidade'}}</label>
          <select class="form-control input-validate" [formControl]="form.controls.tipo" name="unidadetipo" id="unidadetipo">
            <option value=0>Selecione</option>
            <option *ngFor="let o of listaTipoUnidade" [value]="o.id">{{o.nome}}</option>
          </select>
          <app-msg-erro [control]="form.controls.tipo"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-4 p-2" *ngIf="campoEditavel">
          <label for="precoconsultas">Tabela Preço Consultas</label>
          <select class="form-control input-validate" [formControl]="form.controls.tabelaPrecoConsulta" name="precoconsultas" id="precoconsultas">
            <option value="">Selecione</option>
            <option *ngFor="let o of listaPrecoConsulta" [value]="o.id">{{o.id}} / {{o.nome}}</option>
          </select>
          <app-msg-erro [control]="form.controls.tabelaPrecoConsulta"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-4 p-2" *ngIf="campoEditavel">
          <label for="precotipolaudoid">Tabela Preço Tipo Laudo</label>
          <select class="form-control input-validate" [formControl]="form.controls.tabelaPrecoTipoLaudo" name="precotipolaudo" id="precotipolaudo">
            <option value=0>Selecione</option>
            <option *ngFor="let o of listaPrecoTipoLaudo" [value]="o.id">{{o.id}} / {{o.nome}}</option>
          </select>
          <app-msg-erro [control]="form.controls.tabelaPrecoTipoLaudo"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-4 p-2" *ngIf="campoEditavel">
          <label for="valorconsultoria">Valor Consultoria</label>
          <input [readonly]="desativarInputsEBotoes" type="text" [textMask]="masks.moeda" autocomplete="false" class="form-control input-validate" [formControl]="form.controls.valorConsultoria" name="valorconsultoria" id="valorconsultoria">
          <app-msg-erro [control]="form.controls.valorConsultoria"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-4 p-2">
          <label for="Telefone">Contatos</label>
          <input [readonly]="desativarInputsEBotoes" type="text" required autocomplete="false" class="form-control input-validate" [formControl]="form.controls.telefone" name="Telefone" id="Telefone">
          <app-msg-erro [control]="form.controls.telefone"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-4 p-2">
          <label for="Email">E-mail</label>
          <input [readonly]="desativarInputsEBotoes" type="email" required autocomplete="false" class="form-control input-validate" [formControl]="form.controls.email" name="Email" id="Email">
          <app-msg-erro [control]="form.controls.email"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-4 p-2" *ngIf="campoEditavel">
          <label for="IDCarsys">Data de Cadastro da Unidade</label>
          <input [readonly]="desativarInputsEBotoes" autocomplete="false" class="form-control input-validate" [formControl]="form.controls.idCarsys" name="IDCarsys" id="IDCarsys">
          <app-msg-erro [control]="form.controls.idCarsys"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-4 p-2" *ngIf="campoEditavel">
          <label for="ClienteRG">Cliente RG</label>
          <select class="form-control input-validate" [formControl]="form.controls.tokenRg" name="ClienteRG" id="ClienteRG">
            <option value=0>Selecione</option>
            <!--option *ngFor="let o of listaPrecoTipoLaudo" value="o.id">{{o.nome}}</option -->
          </select>
          <app-msg-erro [control]="form.controls.tokenRg"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-4 p-2" *ngIf="campoEditavel">
          <label for="gerarNota">Tipo de faturamento</label>
          <select class="form-control input-validate" [formControl]="form.controls.gerarNota" name="gerarNota" id="gerarNota">
            <option value=''>Selecione</option>
            <option value='FATURA'>Fatura</option>
            <option value='RECIBO'>Recibo</option>
          </select>
          <app-msg-erro [control]="form.controls.gerarNota"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-4 p-2 pt-4 mt-2" *ngIf="campoEditavel">
          <app-checkbox [(disabled)]="desativarInputsEBotoes" size="lg" [(checked)]="unidade.exibirDocumentoConsultas" label="Exibir documento da consulta?"></app-checkbox>
        </div>
      </div>
    </div>
    <div class="card-header mt-4 bg-white">
      <h3>Endereço</h3>
    </div>
    <div class="card-body row">
      <div class="col-12 col-lg-4 p-2">
        <label for="CEP">CEP</label>
        <input [readonly]="desativarInputsEBotoes" type="text" required minlength="10" maxlength="10" [textMask]="masks.cep" autocomplete="false" class="form-control input-validate" [formControl]="formEndereco.controls.cep" name="cep" id="cep">
        <app-msg-erro [control]="formEndereco.controls.cep"></app-msg-erro>
      </div>
      <div class="col-12 col-lg-4 p-2">
        <label for="numeroend">Número</label>
        <input [readonly]="desativarInputsEBotoes" type="number" required autocomplete="false" class="form-control input-validate" [formControl]="formEndereco.controls.numero" name="numeroend" id="numeroend">
        <app-msg-erro [control]="formEndereco.controls.numero"></app-msg-erro>
      </div>
      <div class="col-12 col-lg-4 p-2">
        <label for="Rua">Rua</label>
        <input [readonly]="desativarInputsEBotoes" type="text" required autocomplete="false" class="form-control input-validate" [formControl]="formEndereco.controls.rua" name="rua" id="Rua">
        <app-msg-erro [control]="formEndereco.controls.rua"></app-msg-erro>
      </div>
      <div class="col-12 col-lg-4 p-2">
        <label for="Bairro">Bairro</label>
        <input [readonly]="desativarInputsEBotoes" type="text" required autocomplete="false" class="form-control input-validate" [formControl]="formEndereco.controls.bairro" name="bairro" id="Bairro">
        <app-msg-erro [control]="formEndereco.controls.bairro"></app-msg-erro>
      </div>
      <div class="col-12 col-lg-4 p-2">
        <label for="Cidade">Cidade</label>
        <input [readonly]="desativarInputsEBotoes" type="text" required autocomplete="false" class="form-control input-validate" [formControl]="formEndereco.controls.cidade" name="cidade" id="Cidade">
        <app-msg-erro [control]="formEndereco.controls.cidade"></app-msg-erro>
      </div>
      <div class="col-12 col-lg-4 p-2">
        <label for="uf">Estado</label>
        <select class="form-control input-validate" [formControl]="formEndereco.controls.estado" name="uf" id="uf">
          <option value="">Selecione</option>
          <option *ngFor="let o of listaEstados" [value]="o.value">{{o.label}}</option>
        </select>
        <app-msg-erro [control]="formEndereco.controls.estado"></app-msg-erro>
      </div>
      <div class="col-12 col-lg-4 p-2">
        <label for="Complemento">Complemento</label>
        <input [readonly]="desativarInputsEBotoes" type="text" autocomplete="false" class="form-control input-validate" [formControl]="formEndereco.controls.complemento" name="complemento" id="Complemento">
        <app-msg-erro [control]="formEndereco.controls.complemento"></app-msg-erro>
      </div>
    </div>
  </div>
  <div *ngIf="!id" class="card mt-4">
    <div class="card-header bg-white">
      <h3>Dados de login</h3>
    </div>
    <div class="card-body row">
      <div class="col-12 col-lg-7 p-2">
        <label for="NomeCompleto">Nome Completo</label>
        <input [readonly]="desativarInputsEBotoes" type="text" required autocomplete="false" class="form-control input-validate" [formControl]="formUsuario.controls.nome" name="NomeCompleto" id="NomeCompleto">
        <app-msg-erro [control]="formUsuario.controls.nome"></app-msg-erro>
      </div>
      <div class="col-12 col-lg-5 p-2">
        <label for="login">Login</label>
        <input [readonly]="desativarInputsEBotoes" type="text" required autocomplete="false" class="form-control input-validate" [formControl]="formUsuario.controls.login" name="login" id="login">
        <app-msg-erro [control]="formUsuario.controls.login"></app-msg-erro>
      </div>
      <div class="col-12 col-md-6 col-lg-3 p-2">
        <label for="senha">Senha</label>
        <input [readonly]="desativarInputsEBotoes" required autocomplete="false" type="password" class="form-control input-validate" [formControl]="formUsuario.controls.senha" name="senha" id="senha">
        <app-msg-erro [control]="formUsuario.controls.senha"></app-msg-erro>
      </div>
      <div class="col-12 col-md-6 col-lg-3 p-2">
        <label for="confSenha">Confirmação de Senha</label>
        <input [readonly]="desativarInputsEBotoes" required autocomplete="false" type="password" class="form-control input-validate" [formControl]="formUsuario.controls.senhaConf" name="confSenha" id="confSenha">
        <app-msg-erro [control]="formUsuario.controls.senhaConf"></app-msg-erro>
      </div>
      <div class="col-12 col-md-6 col-lg-3 p-2">
        <label for="email">E-mail</label>
        <input [readonly]="desativarInputsEBotoes" type="email" required autocomplete="false" class="form-control input-validate" [formControl]="formUsuario.controls.email" name="email" id="email">
        <app-msg-erro [control]="formUsuario.controls.email"></app-msg-erro>
      </div>
      <div class="col-12 col-md-6 col-lg-3 p-2">
        <label for="confEmail">Confirmação de E-mail</label>
        <input [readonly]="desativarInputsEBotoes" type="email" required autocomplete="false" class="form-control input-validate" [formControl]="formUsuario.controls.emailConf" name="confEmail" id="confEmail">
        <app-msg-erro [control]="formUsuario.controls.emailConf"></app-msg-erro>
      </div>

      <div class="col-12 col-lg-4 p-2">
        <app-checkbox [(disabled)]="desativarInputsEBotoes" [(checked)]="unidade.usuario.administrador" label="Administrador?"></app-checkbox>
      </div>
      <div class="col-12 col-lg-4 p-2">
        <app-checkbox [(disabled)]="desativarInputsEBotoes" [(checked)]="unidade.usuario.acessoTodasConsultas" label="Visualizar histórico de terceiros?"></app-checkbox>
      </div>
      <div class="col-12 col-lg-4 p-2">
        <app-checkbox [(disabled)]="desativarInputsEBotoes" [(checked)]="unidade.usuario.exibirConsultaAvulsa" label="Exibir consulta avulsa?"></app-checkbox>
      </div>
      <!-- <div class="col-12 col-lg-4 p-2">
        <app-checkbox [(disabled)]="desativarInputsEBotoes" [(checked)]="unidade.usuario.editarLaudo" label="Editar Laudo?"></app-checkbox>
      </div>
      <div class="col-12 col-lg-4 p-2">
        <app-checkbox [(disabled)]="desativarInputsEBotoes" [(checked)]="unidade.usuario.somenteVisualizacao" label="Somente visualização?"></app-checkbox>
      </div>
      <div class="col-12 col-lg-4 p-2">
        <app-checkbox [(disabled)]="desativarInputsEBotoes" [(checked)]="unidade.usuario.acessoConsultaEspecial" label="Acesso à Decisão Certa?"></app-checkbox>
      </div> -->
    </div>

    <div class="card-header mt-4 bg-white">
      <h3>Autorizações</h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div *ngFor="let r of listaPermissaoUsuario" class="col-12 col-lg-4 p-2">
          <app-checkbox [(disabled)]="desativarInputsEBotoes" [(checked)]="r.checked" [label]="r.nome"></app-checkbox>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="campoEditavel">
    <div class="card mt-4">
      <div class="card-header bg-white">
        <h3>Consultas Veiculares</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <ng-container>
            <div *ngFor="let r of listaConsultas" class="col-12 col-lg-4 p-2">
              <app-checkbox [(disabled)]="desativarInputsEBotoes" [(checked)]="r.checked" [label]="r.nome"></app-checkbox>
            </div>
          </ng-container>
          <!-- <ng-container>
            <div class="text-center py-5 text-secondary w-100" colspan="7">
              Sem registros
            </div>
          </ng-container> -->
        </div>
      </div>
    </div>
    <div class="card mt-4">
      <div class="card-header bg-white">
        <h3>Consultas Combinadas</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <ng-container>
            <div *ngFor="let r of listaConsultasCombinadas" class="col-12 col-lg-4 p-2">
              <app-checkbox [(disabled)]="desativarInputsEBotoes" [(checked)]="r.checked" [label]="r.nome"></app-checkbox>
            </div>
          </ng-container>
          <!-- <ng-container>
            <div class="text-center py-5 text-secondary w-100" colspan="7">
              Sem registros
            </div>
          </ng-container> -->
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="campoEditavel">
    <div class="card mt-4">
      <div class="card-header bg-white">
        <h3>Consultas de Crédito</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <ng-container>
            <div *ngFor="let r of listaConsultaCredito" class="col-12 col-lg-4 p-2">
              <app-checkbox [(disabled)]="desativarInputsEBotoes" [(checked)]="r.checked" [label]="r.nome"></app-checkbox>
            </div>
          </ng-container>
          <!-- <ng-container>
            <div class="text-center py-5 text-secondary w-100" colspan="7">
              Sem registros
            </div>
          </ng-container> -->
        </div>
      </div>
    </div>
  </ng-container>


  <div class="card-body bg-white d-flex justify-content-end">
    <button *ngIf="!desativarInputsEBotoes" (click)="sendForm()" class="btn btn-lg px-5 btn-success">
      <span>Salvar</span>
    </button>
  </div>

</section>
